export default {
      id: "arrow_btn-usage",
      viewBox: "0 0 10 11",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_btn",
      toString: function () {
        return this.url;
      }
    }